import React from 'react';
import { isFalsy, isTruthy, Lang, isDefined, addSeparator, _cs, formattedNormalize } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

/**
 * NumberOutput component for formatted numbers
 */
function NumberOutput(props) {
  const {
    className,
    invalidText = '-',
    normal,
    precision,
    prefix,
    separator = ',',
    showSign,
    suffix,
    valueModifier,
    value,
    signClassName,
    prefixClassName,
    numberClassName,
    normalizationSuffixClassName,
    suffixClassName,
    tooltip,
    normalizer = formattedNormalize
  } = props;
  const [number, normalizationSuffix] = React.useMemo(() => {
    if (isFalsy(value)) {
      return [];
    } // Only use absolute part if showSign is true (sign are added later)


    let num = isTruthy(showSign) ? Math.abs(value) : value; // Get normalize-suffix and reduce the number

    let nSuffix;

    if (normal) {
      const {
        number: n,
        normalizeSuffix: ns
      } = normalizer(num, Lang.en);
      num = n;
      nSuffix = ns;
    }

    const integer = Math.floor(num);
    const fraction = num - integer;
    let formattedNumber = String(num); // Convert number to fixed precision

    if (isTruthy(precision)) {
      let p = 2;

      if (precision === 'auto') {
        const absoluteValue = Math.abs(num);

        if (absoluteValue < 1) {
          p = Math.ceil(-Math.log10(absoluteValue)) + 1;
        }

        if (integer > 100) {
          // 140.1234M -> 140 M
          p = 0;
        } else {
          // 96.0334M -> 96.03 M
          if (fraction > 0.01) {
            p = 2;
          }

          p = 0;
        }
      } else {
        p = precision;
      }

      formattedNumber = num.toFixed(p);
    } // Convert number to add separator


    if (isDefined(separator) && fraction === 0) {
      formattedNumber = addSeparator(num, separator);
    }

    return [formattedNumber, nSuffix];
  }, [value, showSign, normal, precision, separator, normalizer]);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.numberOutput, className),
    title: isDefined(tooltip) ? String(tooltip) : undefined
  }, isFalsy(value) ? invalidText : /*#__PURE__*/React.createElement(React.Fragment, null, isTruthy(prefix) && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.prefix, prefixClassName)
  }, prefix), isTruthy(showSign) && value !== 0 && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.sign, signClassName)
  }, value > 0 ? '+' : '-'), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.number, numberClassName)
  }, valueModifier ? valueModifier(number) : number), isTruthy(normalizationSuffix) && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.normalizationSuffix, normalizationSuffixClassName)
  }, normalizationSuffix), isTruthy(suffix) && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.suffix, suffixClassName)
  }, suffix)));
}

var NumberOutput$1 = genericMemo(NumberOutput);

export { NumberOutput$1 as default };
//# sourceMappingURL=index.js.map
